import React from "react";
import { CheckCircle2 } from "lucide-react";
import HeroBackground from "@/components/HeroBackground";
import FinalCTA from "@/components/FinalCTA";
import SectionHeading from "@/components/SectionHeading";
import { useT } from "@/i18n";

export default function About() {
  const t = useT();
  return (
    <div>
      <section className="relative overflow-hidden">
        <HeroBackground />
        <div className="relative nx-container pt-16 md:pt-24 pb-20 md:pb-28">
          <div className="nx-mono text-xs uppercase tracking-[0.32em] text-[#38D8FF] mb-5 nx-fade-in">
            / {t.aboutPage.eyebrow}
          </div>
          <h1 className="nx-heading text-5xl sm:text-6xl lg:text-7xl font-bold leading-tight max-w-4xl tracking-tight nx-fade-in">
            <span className="nx-gradient-text">{t.aboutPage.title1}</span>
            <br />
            {t.aboutPage.title2}
          </h1>
          <p className="mt-6 max-w-2xl text-lg text-white/75 leading-relaxed nx-fade-in">
            {t.aboutPage.lede}
          </p>

          <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-3xl">
            {t.trustStats.map((s) => (
              <div key={s.label}>
                <div className="nx-heading text-3xl md:text-4xl font-bold text-white">{s.value}</div>
                <div className="mt-1 text-xs text-white/55 uppercase tracking-[0.18em]">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="nx-container py-24 md:py-32 grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5">
          <SectionHeading eyebrow={t.aboutPage.missionEyebrow} title={t.aboutPage.missionTitle} />
        </div>
        <div className="lg:col-span-7 space-y-5 text-white/75 leading-relaxed">
          <p>{t.aboutPage.missionPara1}</p>
          <p>{t.aboutPage.missionPara2}</p>
          <ul className="space-y-3 pt-4">
            {t.aboutPage.missionList.map((l) => (
              <li key={l} className="flex items-start gap-3 text-sm">
                <CheckCircle2 className="w-4 h-4 mt-0.5 text-[#38D8FF]" /> {l}
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="border-t border-white/10 bg-[#050F22]/60">
        <div className="nx-container py-24 md:py-28">
          <SectionHeading eyebrow={t.principles.eyebrow} title={t.principles.title} lede={t.principles.lede} />
          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
            {t.principles.items.map((p, i) => (
              <div key={p.title} className="nx-card rounded-2xl p-6">
                <div className="nx-mono text-xs text-[#38D8FF] mb-4">/ 0{i + 1}</div>
                <h3 className="nx-heading text-lg font-semibold">{p.title}</h3>
                <p className="mt-3 text-sm text-white/65 leading-relaxed">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <FinalCTA />
    </div>
  );
}
